module.exports = {
  messages: {
    PD_100_DESCR:
      'More than 21 million people are already using XING to manage their business contacts. Browse through the member directory to see who you know!',
    PD_100_HEADING: 'XING member directory',
    PD_100_TITLE: 'Member directory',
    PD_200_NAMES_LIKE: 'Like',
    PD_CARD_BUTTON: 'Go to profile',
    PD_CITIES_PEOPLE_IN_CITIES_HEADLINE: 'Members by city',
    PD_CITIES_TOP_CITIES_META_DESCRIPTION:
      'XING member directory - find your business contacts from over 21 million members',
    PD_CITIES_TOP_CITIES_TITLE: 'XING member directory: Members by city | XING',
    PD_EMPTY_STATE_DESCRIPTION:
      "There aren't any members whose name starts with this letter.",
    PD_EMPTY_STATE_HEADLINE: 'All quiet around here',
    PD_EMPTY_STATE_USER_BAGS_PAGE_DESCRIPTION:
      'Try searching again with a different job title or location.',
    PD_EMPTY_STATE_USER_BAGS_PAGE_HEADLINE: 'No members matching your search',
    PD_ERROR_STATE_BUTTON_LABEL: 'Reload page',
    PD_ERROR_STATE_DESCRIPTION: 'Please try refreshing the page.',
    PD_ERROR_STATE_HEADLINE: "That didn't work.",
    PD_LETTER_ROOT_TITLE: '{display_name} on xing.com | XING',
    PD_LOGIN_TO_SEARCH: 'Log in to search for members',
    PD_META_DESCRIPTION_LVL_1:
      '{display_name} - Find business contacts in {cities} and other cities!',
    PD_USER_BAG_COMPONENT_BUTTON_LABEL: 'Show more',
    PD_USER_BAG_COMPONENT_DESCRIPTION:
      'There are <strong>{children_count}</strong> XING members by the name of  {display_name}.',
  },
};
